module.exports = __webpack_public_path__ + "static/media/custom-review-box.d7a3241d.svg";